module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jlFPm"))).then(() => parcelRequire('ikE14'));